import React from "react";
import DynamicSelect from "../shared/DynamicSelect";
import { formatValidInput, formatValidSelect, roundToDecimals } from "../../helpers/FormatHelper";
import { useState } from "react";
import NumberInput from "../shared/NumberInput";
import { DeleteTwoTone, RemoveCircleOutline, AddCircleOutlineOutlined } from "@material-ui/icons";
import { useEffect } from "react";
import { DenominationTypes } from "../../constants/DenominationTypes";
import OrderInformationDenomination from "./OrderInformationDenomination";
import { calculateBuyAmount, calculateOrderRowAmount, getRateAndAmounts } from "./OrderService";

export function OrderInformationRow({customerID,rowObject, rowID, buyCurrency, currenciesList,lockedSide, buyScale, onDeleteRow, onUpdateFieldRow, validations, onUpdateRowAmounts, deliveryDate, autoFocus, openAlert, editCostRate}){

    const [amount, setAmount] = useState(0);
    const [buyAmount, setBuyAmount] = useState(0);
    const [rate, setRate] = useState(0);
    const [costRate, setCostRate] = useState(0);
    const [profit, setProfit] = useState(0);
    const [ratePrecision, setRatePrecision] = useState(0);
    const [currencyID, setCurrencyID] = useState('');
    const [sellScale, setSellScale] = useState(2);  
    const [showDenominations, setShowDenominations] = useState(false);
    const [denominationType, setDenominationType] = useState(DenominationTypes.notes);
    const [denominations, setDenominations] = useState([]);

    useEffect(() => {
    if (rowObject.CurrencyID && (rowObject.Denominations?.length > 0 || rowObject.MixedNotes)) {     
        const selectCcy = currenciesList.find(c=> c.value===rowObject.CurrencyID);
        if(selectCcy)
        {
            dropdownCurrenciesChangeHandler(selectCcy);
        }
        setAmount(rowObject.Amount);
        setRate(rowObject.Rate);
        setCostRate(rowObject.CostRate);
        setProfit(rowObject.Profit);
        setBuyAmount(rowObject.BuyAmount);
        setDenominationType(rowObject.DenominationType);
        setRatePrecision(rowObject.RatePrecision);
        setSellScale(rowObject.CurrencyScale);
    }
  }, [rowObject, currenciesList]);

   useEffect(() => {
    const updateRates = async () =>{
      if(amount > 0)
      {
        const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, amount, lockedSide,[], denominationType, buyScale, buyCurrency);
        if(rateResponse.Message && rateResponse.Message !== '')
        {
          openAlert('Error',rateResponse.Message );
        }
        else
        {
          onUpdateRowAmounts(rowID, amount, rateResponse.CustomerRate, rateResponse.BuyAmount, 0 ,denominations, rateResponse.Profit, rateResponse.CostRate, rateResponse.RatePrecision, rateResponse.RateTerms);
          setRatePrecision(rateResponse.RatePrecision);
          setBuyAmount(rateResponse.BuyAmount);
          setRate(rateResponse.CustomerRate);
          setCostRate(rateResponse.CostRate);
          setProfit(rateResponse.Profit);
        }
      }
    }
    if (buyCurrency !== '') {
        updateRates()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buyCurrency]);

    const dropdownCurrenciesChangeHandler = (item) =>
    {
       if(item.value && item.value !== '')
      { 
   if(rowObject.CurrencyID !== '' && rowObject.CurrencyID === item.value && (rowObject.Denominations.length > 0 || rowObject.MixedNotes))
    {
        let denominationsRow = rowObject.Denominations.filter(dr => dr.NoNotes !== '' && Number(dr.NoNotes)> 0);
        let denAux = item.Denominations;

        if(denAux && denAux.length > 0 && denominationsRow )
        {
          denAux.forEach(d => {
            const denOrder = denominationsRow.filter(dr => dr.DenominationDescription === d.DenominationDescription);
            if(denOrder && denOrder.length >0)
            {
              d.NoNotes = denOrder[0].NoNotes;
              d.DenominationFee = denOrder[0].DenominationFee;
            }
            else
            {
              d.NoNotes = 0;
              d.DenominationFee = 0;
            }
            d.valid = true;
          })
          setDenominations(denAux);
        }      
        setCurrencyID(rowObject.CurrencyID);
    }
    else{
      setCurrencyID(item.value);
      let denAux = [];
      if(item.Denominations)
      {        
        denAux = JSON.parse(JSON.stringify(item.Denominations));
        denAux.forEach((d) =>{
            d.valid = true;
            d.NoNotes = 0;
        })        
      }
      setDenominations(denAux);
      setBuyAmount(0);
      setRate(0);
      setCostRate(0);
      setProfit(0);
      setAmount(0);
      
      onUpdateFieldRow(rowID, 'CurrencyID', item.value);
      onUpdateFieldRow(rowID, 'CurrencyName', item.name);
      onUpdateFieldRow(rowID, 'CurrencyScale', item.NumberOfDecimals);
      onUpdateRowAmounts(rowID, 0, 0, 0, 0 ,denAux, 0, 0, 8,'D');
      //onUpdateFieldRow(rowID, 'Denominations', denAux);
    }
    
    setShowDenominations(true);
  }
    }

    const onBlurAmount = async() =>{
        clearDenominations();
        const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, amount, lockedSide,[], denominationType, buyScale, buyCurrency);
        onUpdateRowAmounts(rowID, amount, rateResponse.CustomerRate, rateResponse.BuyAmount, 0 ,denominations, rateResponse.Profit, rateResponse.CostRate, rateResponse.RatePrecision, rateResponse.RateTerms);
        setRatePrecision(rateResponse.RatePrecision);
        setBuyAmount(rateResponse.BuyAmount);
        setRate(rateResponse.CustomerRate);
        setCostRate(rateResponse.CostRate);
        setProfit(rateResponse.Profit);
    }

    const onBlurBuyAmount = async() => { //buySide    
        clearDenominations();
        const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, buyAmount, lockedSide.toLowerCase()==='sell'?'buy': 'sell',[], denominationType, buyScale, buyCurrency);
        onUpdateRowAmounts(rowID, rateResponse.BuyAmount, rateResponse.CustomerRate, buyAmount, 0, denominations, rateResponse.Profit, rateResponse.CostRate, rateResponse.RatePrecision, rateResponse.RateTerms);
        setRatePrecision(rateResponse.RatePrecision);
        setAmount(rateResponse.BuyAmount);
        setRate(rateResponse.CustomerRate);
        setCostRate(ratePrecision.CostRate);
        setProfit(ratePrecision.Profit);
    }
    
    const onDeleteOrderRow = () => {
      onDeleteRow(rowID);
    };
  

  const onClickMore = () => {
    setShowDenominations(!showDenominations);   
  };

  const denominationIsValid = (denominations) =>{
    let valid = true;
    if(denominationType === DenominationTypes.amount)
    {
      if(denominations)
      {
        //const denominationsAux = JSON.parse(JSON.stringify(denominations))
        denominations.forEach((d)=>{          
          d.valid = (d.NoNotes === 0) || ((d.NoNotes > 0) && (d.DenominationValue <= d.NoNotes && d.NoNotes % d.DenominationValue === 0))     
          if(!d.valid) {valid = false}
        })
        setDenominations(denominations);
      }
    }

    return valid;
  }

  const onBlurDenominationValue = async(values) =>{

        const denominationsAux = JSON.parse(JSON.stringify(denominations));
    denominationsAux.forEach((d, index)=>{ 
        d.NoNotes = values[index];
       });
     if(denominationIsValid(denominationsAux))
    {
      //const denominationsAux = JSON.parse(JSON.stringify(denominations));
      const rowAmount = calculateOrderRowAmount(denominationsAux, denominationType);
      if(rowAmount !== amount)
      {
        setAmount(rowAmount);
        
        const rateResponse = await getRateAndAmounts(customerID, deliveryDate, currencyID, rowAmount, lockedSide, denominationsAux, denominationType, buyScale, buyCurrency);
        
        const denominationsWithFee = [...denominationsAux];
        const denominationsFee = rateResponse.Denominations;
      
        let fee = 0;
        denominationsWithFee.forEach((d) => {
          if(denominationsFee && d.NoNotes > 0)
          {
            const denominationFee = denominationsFee.find((f) => d.DenominationDescription === f.DenominationDescription);
            d.DenominationFee = (denominationFee)?denominationFee.DenominationFee : 0;
            fee += (denominationFee)?denominationFee.DenominationFee : 0;
          }
          else
          {
            d.DenominationFee = 0;
          }
        })

        setDenominations(denominationsWithFee);

        onUpdateRowAmounts(rowID, rowAmount, rateResponse.CustomerRate, rateResponse.BuyAmount, fee, denominationsWithFee, rateResponse.Profit, rateResponse.CostRate, rateResponse.RatePrecision, rateResponse.RateTerms);
        setRatePrecision(rateResponse.RatePrecision);
        setBuyAmount(rateResponse.BuyAmount);
        setRate(rateResponse.CustomerRate);
        setCostRate(rateResponse.CostRate);
        setProfit(rateResponse.Profit);
      }
    }
  }

    const onUpdateDenominationValue = (value, index) =>{
    const denominationsAux = JSON.parse(JSON.stringify(denominations));
    denominationsAux[index].NoNotes =  value;    
    setDenominations(denominationsAux);
  }

  const onUpdateMixedNotes = (checked) =>{
    onUpdateFieldRow(rowID, 'MixedNotes', checked);
    const denAux = clearDenominations();
    onUpdateRowAmounts(rowID, 0,0,0,0, denAux,0,0,0,'D');
  }


   const onUpdateDenominationType = (checked) =>{
    const denType =  (checked)?DenominationTypes.notes: DenominationTypes.amount;
    setDenominationType(denType);
    onUpdateFieldRow(rowID, 'DenominationType', denType);
    const denAux = clearDenominations();
    onUpdateRowAmounts(rowID, 0,0,0,0, denAux,0,0,0,'D');
  }

  const clearDenominations = () =>{
    const denominationsAux = JSON.parse(JSON.stringify(denominations))
    denominationsAux.forEach(d => {d.NoNotes = 0; d.DenominationFee = 0;});
    setDenominations(denominationsAux);
    return denominationsAux;
  }

  const onBlurRate = ()=>{        
          
          const orderRowAux = JSON.parse(JSON.stringify(rowObject))
  
          const amountByRate = calculateBuyAmount(orderRowAux.RateTerms, rate, lockedSide, orderRowAux.Amount, buyScale);
          const amountByCostRate = calculateBuyAmount(orderRowAux.RateTerms, orderRowAux.CostRate, lockedSide, orderRowAux.Amount, buyScale);
          const profit = roundToDecimals(amountByRate - amountByCostRate, buyScale);

      onUpdateFieldRow(rowID, 'Rate', rate);
      onUpdateFieldRow(rowID, 'Profit', profit);
      onUpdateFieldRow(rowID, 'BuyAmount', amountByRate);

  }

    const onBlurCostRate = ()=>{        
          
          const orderRowAux = JSON.parse(JSON.stringify(rowObject))
  
          const amountByRate = calculateBuyAmount(orderRowAux.RateTerms, orderRowAux.Rate, lockedSide, orderRowAux.Amount, buyScale);
          const amountByCostRate = calculateBuyAmount(orderRowAux.RateTerms, costRate, lockedSide, orderRowAux.Amount, buyScale);
          const profit = roundToDecimals(amountByRate - amountByCostRate, buyScale);

      onUpdateFieldRow(rowID, 'CostRate', costRate);
      onUpdateFieldRow(rowID, 'Profit', profit);
  }



    return <>
    <tr key={rowID}>
        <td>
            <DynamicSelect
              className={formatValidSelect(validations.CurrencyID)}
              id={`dd-currencies-${rowID}`}
              key={`dd-currencies-${rowID}`}
              data={currenciesList}
              getValue={dropdownCurrenciesChangeHandler}
              objValue={{ value: currencyID }}
              placeholder={'Select currency...'}
              autoFocus={autoFocus}
            />
        </td>
        <td>
            <NumberInput id={`txt-amount-${rowID}`} key={`txt-amount-${rowID}`} className={formatValidInput(validations.Amount)} value={amount} 
            onBlur={onBlurAmount} onChange ={(event) => {setAmount(event.target.value);}} scale={sellScale} type="Currency" />
        </td>
        {editCostRate &&
        <td>
            <NumberInput id={`costrate-${rowID}`} key={`costrate-${rowID}`} className={formatValidInput(validations.Rate)} value={costRate} 
                    scale={ratePrecision} onBlur={onBlurCostRate} onChange ={(event) => {setCostRate(event.target.value);}} type="Rate"/>
        </td>}
        <td>
            <NumberInput id={`rate-${rowID}`} key={`rate-${rowID}`} className={formatValidInput(validations.Rate)} value={rate} 
                    scale={ratePrecision} onBlur={onBlurRate} onChange ={(event) => {setRate(event.target.value);}} type="Rate"/>
        </td>
        
        <td>
            <NumberInput id={`buyAmount-${rowID}`} key={`buyAmount-${rowID}`} className={formatValidInput(validations.BuyAmount)} value={buyAmount} 
            onBlur={onBlurBuyAmount} onChange ={(event) => {setBuyAmount(event.target.value);}} scale={buyScale} disabled={true} type="Currency" />
        </td>
        {editCostRate &&
        <td>
            <NumberInput id={`profit-${rowID}`} key={`profit-${rowID}`} className={formatValidInput(validations.Rate)} value={profit} 
                    scale={buyScale} disabled={true} type="Currency" negative={true}/>
        </td>}
        <td>
            <DeleteTwoTone id={`delete-row-${rowID}`} key ={`delete-row-${rowID}`} style={{ marginRight: '20px', marginTop: '10px' }} onClick={onDeleteOrderRow} twoToneColor="#34c521"  />
          {!showDenominations && <AddCircleOutlineOutlined id={`show-den-row-${rowID}`} key ={`show-den-row-${rowID}`} style={{ marginTop: '10px' }} onClick={onClickMore} twoToneColor="#34c521"  />}
          {showDenominations && <RemoveCircleOutline id={`hide-den-row-${rowID}`} key ={`hide-den-row-${rowID}`} style={{ marginTop: '10px' }} onClick={onClickMore} twoToneColor="#34c521"  />}
        </td>

    </tr>
    {showDenominations &&<tr key={`tr-den-${rowID}`}>
        <td colSpan={6}>
            <OrderInformationDenomination denominations={denominations} rowKey={`den-${rowID}`} onUpdateDenominationValue={onUpdateDenominationValue}
            onBlurDenominationValue={onBlurDenominationValue} valid={validations.Denominations} onUpdateDenominationType={onUpdateDenominationType}
             onUpdateMixedNotes={onUpdateMixedNotes} mixedNotes={rowObject.MixedNotes} lockedSide={lockedSide} currencyID={currencyID}/>
        </td>
    </tr>}
    </>

}

export default OrderInformationRow